module.exports = __webpack_public_path__ + "static/media/icon_loan.238c8fe1.png";